import { getApiErrorStatus } from './apiErrors'

// The app-wide query retry policy, applied to every query via
// ReactQueryProvider's defaultOptions.
//
// 401/403 can't succeed on retry — 401 means no session, and by the time a
// 403 reaches the client the proxy has already force-refreshed the token and
// retried once (see [...proxy].api.ts). Fail immediately so error states
// (session-expired modal, no-access screen) show without a retry delay.
//
// A query's own `retry` option REPLACES this default rather than composing
// with it, so a hook that needs an extra exclusion should call this and add
// its own case on top instead of rewriting the rule from scratch.
export const defaultQueryRetry = (
  failureCount: number,
  error: unknown,
): boolean => {
  const status = getApiErrorStatus(error)
  if (status === 401 || status === 403) {
    return false
  }
  return failureCount < 3
}

// The default plus one exclusion: a 404 is a missing or unpublished slug
// (subject, module, …), so retrying only delays the error state.
export const retryExcept404 = (
  failureCount: number,
  error: unknown,
): boolean =>
  getApiErrorStatus(error) === 404
    ? false
    : defaultQueryRetry(failureCount, error)
